import d from"../isNullOrUndefined/isNullOrUndefined.js";const e=e=>i=>d(e)?void 0:`${e}${i}`;export{e as default};
//# sourceMappingURL=addPrefix.js.map
